function modalOpen () {
  return document.getElementsByClassName('modal show').length > 0
    || document.getElementsByClassName('login-modal').length > 0
}

export default modalOpen
